/**
 * Behavior for Celebrate Life form
 */
((Drupal, $) => {
  Drupal.behaviors.celebrateLife = {
    attach(context) {
      let $inputAmount = $('#edit-amount', context);
      const $selectStars = $('#edit-more-names', context);
      const $starHome = $('#edit-decoration-star', context);
      Drupal.behaviors.celebrateLife.stars = 0;
      Drupal.behaviors.celebrateLife.homeStars = 0;
      Drupal.behaviors.celebrateLife.totalAmout = 20;

      $selectStars.on('change', function() {
        Drupal.behaviors.celebrateLife.stars = 20 * $selectStars.val();
        Drupal.behaviors.celebrateLife.totalAmout = 20 + Drupal.behaviors.celebrateLife.stars + Drupal.behaviors.celebrateLife.homeStars;
        $inputAmount.val(Drupal.behaviors.celebrateLife.totalAmout);
      });
      $starHome.on('change', function() {
        Drupal.behaviors.celebrateLife.homeStars = 5 * $starHome.val();
        Drupal.behaviors.celebrateLife.totalAmout = 20 + Drupal.behaviors.celebrateLife.stars + Drupal.behaviors.celebrateLife.homeStars;
        $inputAmount.val(Drupal.behaviors.celebrateLife.totalAmout);
      });
    }
  };
})(Drupal, jQuery);
